import { t } from "i18next";
import React, { useEffect } from "react";
import Modal from "react-modal";
import i18n from "../../i18n";
import { useSelector } from "react-redux";
import { showInIQD } from "../../customFunction/Numeral/CurrencyFormat";
import { convertCurrency } from "../../store/actions/dollarPricesAction";

const customStyles = {
  content: {
    display: "flex",
    flexDirection: "column",
    top: "50%",
    left: "50%",
    right: "auto",
    height: "fit-content",
    width: "40%",
    bottom: "auto",
    marginRight: "-50%",
    padding: "4px",
    borderRadius: "0px",
    transform: "translate(-50%, -50%)",
  },
};

function ExpensesCalculationPriceModal({
  priceModal,
  onChangeModal,
  onChangeModalData,
  onSubmit,
}) {
  const currentDollarPrice = useSelector(
    (state) => state.dollarPrices.currentPrice.price
  );
  const onChangePayedType = (key, type) => {
    onChangeModalData({
      ...priceModal,
      [key]: type,
    });
  };

  const onChangeAmountByCustomer = (amount, type, currency) => {
    if (type === 0) {
      if (amount) {
        amount = Number(amount);
        // console.log(amount)
        onChangeModalData({
          ...priceModal,
          paymentDetails: {
            ...priceModal.paymentDetails,
            amountByCustomer: amount,
          },
        });
      }
    } else {
      //!dollar manually input but for dinar we automatically calculate it
      amount = Number(amount);

      onChangeModalData({
        ...priceModal,
        paymentDetails: {
          ...priceModal.paymentDetails,
          [currency]: amount,
        },
      });
    }
  };

  useEffect(() => {
    onChangeModalData({
      ...priceModal,
      paymentDetails: {
        ...priceModal.paymentDetails,
        changePrice: 0,
        amountByCustomer: 0,
      },
    });
  }, [priceModal.payedType]);

  const onValidation = () => {
    if (
      priceModal.payedType !== 2 &&
      !priceModal.paymentDetails.amountByCustomer
    ) {
      alert("please enter dollar amount");
    } else if (
      priceModal.payedType === 2 &&
      (!priceModal.paymentDetails.dollarAmount ||
        priceModal.paymentDetails.dollarAmount < 0 ||
        !priceModal.paymentDetails.iqdAmount ||
        priceModal.paymentDetails.iqdAmount < 0)
    ) {
      alert("please enter dollar amount");
    } else {
      onSubmit();
    }
  };

  return (
    <div>
      <Modal
        isOpen={priceModal.show}
        onRequestClose={onChangeModal}
        style={customStyles}>
        <div
          className='flex flex-col w-full h-full py-4'
          style={{
            direction: i18n.language === "en" ? "ltr" : "rtl",
            fontFamily: i18n.language === "en" ? "Montserrat" : "aka",
          }}>
          <div className='flex items-center justify-between w-full h-[50px] p-2  bg-black/5'>
            <p className='w-[55%] font-medium '>{t("payedType")}</p>
            <div className='flex justify-between w-[45%]'>
              <div
                onClick={onChangePayedType.bind(this, "payedType", 0)}
                className={`flex items-center justify-center p-1 px-4 ${
                  priceModal.payedType === 0 ? "bg-green-400 text-white" : ""
                }  cursor-pointer`}>
                {t("dollar")}
              </div>
              <div
                onClick={onChangePayedType.bind(this, "payedType", 1)}
                className={`p-2  bg-green-400 ${
                  priceModal.payedType === 1
                    ? "bg-green-400 text-white"
                    : "bg-transparent"
                } cursor-pointer`}>
                {t("iqd")}
              </div>
              <div
                onClick={onChangePayedType.bind(this, "payedType", 2)}
                className={`p-2  bg-green-400 ${
                  priceModal.payedType === 2
                    ? "bg-green-400 text-white"
                    : "bg-transparent"
                } cursor-pointer`}>
                {t("both")}
              </div>
            </div>
          </div>
          {true && (
            <>
              <div className='flex items-center  justify-between h-[50px] w-full p-2 my-4  bg-black/5'>
                <p className='font-medium w-[45%] break-words'>
                  {t("expensesAmount")}
                </p>
                <>
                  {priceModal?.payedType === 2 ? (
                    <>
                      <div className='flex items-center justify-between w-[35%]'>
                        <p>{t("dollar") + ": "}</p>

                        <input
                          type='number'
                          value={priceModal?.paymentDetails?.dollarAmount}
                          onChange={(e) =>
                            onChangeAmountByCustomer(
                              e.target.value,
                              1,
                              "dollarAmount"
                            )
                          }
                          className='p-1 bg-white w-[70%] outline-none mx-2'
                          placeholder={t("dollar")}
                        />
                      </div>
                      <div className='flex items-center justify-between w-[35%]'>
                        <p>{t("iqd") + ": "}</p>
                        <input
                          // disabled
                          onChange={(e) =>
                            onChangeAmountByCustomer(
                              e.target.value,
                              1,
                              "iqdAmount"
                            )
                          }
                          type='number'
                          value={priceModal?.paymentDetails?.iqdAmount}
                          className='p-1 bg-white w-[70%] outline-none'
                          placeholder={t("iqd")}
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      <input
                        type='number'
                        value={priceModal?.paymentDetails?.amountByCustomer}
                        onChange={(e) =>
                          onChangeAmountByCustomer(e.target.value, 0)
                        }
                        className='p-2 bg-white w-[35%] outline-none'
                        placeholder={
                          priceModal.payedType === 0 ? t("dollar") : t("iqd")
                        }
                      />
                    </>
                  )}
                </>
              </div>
              <div className='flex items-center justify-between h-[50px] w-full p-2 mb-4  bg-black/5'>
                <p className='w-1/2 font-medium '>{t("totalPrice")}</p>
                <p className='font-bold'>
                  {priceModal.payedType === 0
                    ? showInIQD(
                        priceModal.paymentDetails.amountByCustomer,
                        "USD"
                      )
                    : priceModal.payedType === 1
                    ? showInIQD(priceModal.paymentDetails.amountByCustomer)
                    : showInIQD(priceModal.paymentDetails.dollarAmount, "USD") +
                      " - " +
                      showInIQD(priceModal.paymentDetails.iqdAmount || 0)}
                </p>
              </div>

              <div
                onClick={onValidation}
                className='flex self-center p-3 bg-blue-500 cursor-pointer w-fit'>
                <p className='font-medium  text-white w-[65%]'>{t("submit")}</p>
              </div>
            </>
          )}
        </div>
      </Modal>
    </div>
  );
}

const calcTotalPricePayedType0 = (priceModal, currentDollarPrice) => {
  return priceModal.data.iqd
    ? Math.ceil(
        priceModal.data.iqd /
          Number((currentDollarPrice - 1000 + "").substring(0, 4))
      )
    : priceModal.data.price;
};
const calcTotalPricePayedType1 = (priceModal, currentDollarPrice) => {
  if (priceModal.data.iqd) {
    return priceModal.data.iqd;
  } else {
    const res = Math.ceil(
      priceModal.data.price *
        Number((currentDollarPrice + 1500 + "").substring(0, 4))
    );
    return Math.ceil(res / 1000) * 1000;
  }
};

export default ExpensesCalculationPriceModal;
